export function isMobilePhone() {
    return /(mobile)/i.test(global.navigator ? global.navigator.userAgent : '') && !isIPad();
}

export function isAndroidPad() {
    return !/(mobile)/i.test(global.navigator ? global.navigator.userAgent : '') && isAndroid();
}

export function isAndroid() {
    return /android|adr/i.test(global.navigator ? global.navigator.userAgent : '');
}

export function isIPad() {
    return /(ipad)/i.test(global.navigator ? global.navigator.userAgent : '');
}

export function isIPhone() {
    return /(iphone)/i.test(global.navigator ? global.navigator.userAgent : '');
}
